import { Component, forwardRef, Inject, Input, OnInit, Optional } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { ManualAssessmentType } from '@app/model/enums/manual-assessment-type.enum';
import { QuestionDTO } from '@app/model/questionDTO.model';
import { QuestionType } from 'library-explorer';
import { PREVIEW_MODE } from '../../constants/injection-tokens';

@Component({
    selector: 'app-manual-assessment-question-widget',
    templateUrl: './manual-assessment-question-widget.component.html',
    styleUrls: ['./manual-assessment-question-widget.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ManualAssessmentQuestionWidgetComponent),
            multi: true
        }
    ],
    standalone: false
})
export class ManualAssessmentQuestionWidgetComponent implements OnInit, ControlValueAccessor {
  @Input() public question: QuestionDTO;

  public questionHash: string;

  public types: typeof ManualAssessmentType = ManualAssessmentType;
  public fileType: ManualAssessmentType;

  public form: FormGroup;

  public disabled = false;

  constructor(
    @Inject(PREVIEW_MODE) @Optional() public previewMode: boolean,
    private readonly formBuilder: FormBuilder) { }

  public ngOnInit() {
    this.questionHash = this.question.questionHash;

    this.form = this.formBuilder.group({
      file: new FormControl(null, Validators.required),
      text: new FormControl('')
    })

    this.fileType = this.question.assignmentType;

    this.form.valueChanges
      .subscribe(() => {
        const isValid = this.form.valid;

        if (!isValid) {
          this.onChange(null);
        }


        const { file, text } = this.form.value;

        const data = {
          questionHash: this.questionHash,
          type: QuestionType.QUESTION_ASSIGNMENT,
          file,
          text
        };

        this.onChange(data);
      });
  }

  onChange = (data: any) => { };
  onTouched = () => { };

  public writeValue(obj: any): void { }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public fileChanged(event): void {
    this.form.get('file')?.patchValue(event);
  }


}
